export default [
  {
    title: 'sidebar.headers.dashboard',
    route: 'home',
    icon: 'GridIcon',
  },
]
